import { Image, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';

import { FC } from 'react';

import {
  ECityType,
  ETransportType,
} from 'shared/repositories/commercial-search-offers/entities/underground_dto_for_offer_snippet/UndergroundDtoForOfferSnippetSchema';
import { Transport } from 'shared/serp/components/Transport';
import { extractUndefined } from 'shared/utils/extractUndefined';

import { mapCityTypeToTransportType } from '../../utils/mapCityTypeToTransportType';

import styles from './SpecialProjectCarouselSlide.css';

type TPromoBuilderUnderground = {
  cityType?: ECityType | null;
  lineColor?: string | null;
  name?: string | null;
  timeDisplay: string;
  transportType: ETransportType;
};

type TPromoBuilderParent = {
  id: number;
  name: string;
  url: string;
  address?: string | null;
};

export type SpecialProjectCarouselSlidePros = {
  id: number;
  imageUrl: string;
  cardUrl: string;
  description: string;
  priceDisplay: string;
  newbuilding: TPromoBuilderParent | null;
  underground: TPromoBuilderUnderground | null;
  onSlideClick: () => void;
  onParentClick: () => void;
};

export const SpecialProjectCarouselSlide: FC<SpecialProjectCarouselSlidePros> = ({
  imageUrl,
  cardUrl,
  description,
  priceDisplay,
  newbuilding,
  underground,
  onParentClick,
  onSlideClick,
}) => {
  return (
    <div className={styles['container']}>
      <a
        className={styles['link']}
        data-testid="SpecialProjectOfferCardLink"
        href={cardUrl}
        rel="noreferrer"
        target="_blank"
        onClick={onSlideClick}
      >
        <div className={styles['preview']}>
          <Image borderRadius={0} height={140} objectFit="contain" src={imageUrl} />
        </div>
        <div className={styles['content']}>
          <UIHeading4 as="h5" data-testid="SpecialProjectOfferCardPrice" whiteSpace="nowrap">
            {priceDisplay}
          </UIHeading4>
          <div className={styles['price-group']}>
            {description && (
              <div className={styles['price']} data-testid="SpecialProjectOfferCardDescription">
                <UIText1>{description}</UIText1>
              </div>
            )}
          </div>
          {underground && underground.name ? (
            <Transport
              iconColor={extractUndefined(underground.lineColor)}
              iconType={extractUndefined(underground.cityType && mapCityTypeToTransportType(underground.cityType))}
              name={underground.name}
              remoteness={extractUndefined(underground.timeDisplay)}
              remotenessType={extractUndefined(underground.transportType)}
            />
          ) : (
            newbuilding?.address && (
              <div className={styles['address']} data-testid="SpecialProjectOfferCardAddress">
                <UIText2>{newbuilding.address}</UIText2>
              </div>
            )
          )}
        </div>
      </a>
      {newbuilding && (
        <a
          className={styles['link-parent']}
          data-testid="SpecialProjectOfferCardParent"
          href={newbuilding.url}
          rel="noreferrer"
          target="_blank"
          onClick={onParentClick}
        >
          <UIText2 color="text-main-default">{newbuilding.name}</UIText2>
        </a>
      )}
    </div>
  );
};
